export const build = { date:"2026-05-05.1737", stage:"alpha" }
